<template>
 <div class="box">
    <div class="app-content">
     <!--<div class="header_bg">-->
           <!--头部区域-->
            <div class="station_header">
                <div class="header_left" >
                    <!--<div class="hltp"><img style="width:97px;height:83px;" src="../img/logo(1).png" alt=""/></div>-->
                    <div class="hlwz">杭电圣光机学院学习平台</div>
                </div>
                <div class="header_right">
                    <div class="langs">
                        <el-dropdown  >
                            <span class="el-dropdown-link">{{$t("langs")}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown">
                                <el-link @click="changeType('zh')" :underline="false">
                                    <el-dropdown-item style="width: 30px;margin:0 5px 0 5px;">{{$t("zh")}}</el-dropdown-item>
                                </el-link>
                                <br>
                                <el-link @click="changeType('en')" :underline="false">
                                    <el-dropdown-item style="width: 30px;margin:0 5px 0 5px;">English</el-dropdown-item>
                                </el-link>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="person">
                        <img src="../img/icon_mrtx.png" />
                    </div>
                    <div class="dl">
                        <el-dropdown  >
                        <span class="el-dropdown-link">{{$t("yhdl")}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown">
                            <el-link @click="handle" :underline="false">
                                <el-dropdown-item >{{$t("tcdl")}}</el-dropdown-item>
                            </el-link>
                        </el-dropdown-menu>
                    </el-dropdown>
                    </div>
                </div>
        </div>
     <!--</div>-->
        <!--内容区域-->
        <div class="bodydiv">
        <div class="main">
            <!--<div class="main_left" >-->

                <div class="main_img">
                    <div>
                        <div style="width: 410px;height: 350px;float: left">
                            <div class="demo-type">
                                <div class="user">
                                    <el-avatar style="font-size: 45px;" icon="el-icon-user-solid"></el-avatar>
                                </div>
                                <div class="grxx">
                                    <p style="margin: 10px;text-align: left">{{$t("yhm")}}:admin</p>
                                    <p style="text-align: left;margin-left:10px">{{$t("gh")}}:31324</p>
                                </div>
                            </div>
                            <div class="main_right" >
                                <div class="main_bottom" >
                                    <div class="mbottom">
                                        <span  >地址:杭州市杭州经济开发区白杨街道2号大街1158号</span> <br>
                                        <span>邮编: 310018</span> <br>
                                        <span>电话: 86915114</span> <br>
                                        <span>Copyright © 2022 圣光机联合学院. All rights reserved.</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mkl">
                            <div class="circle" style="margin: 5px 0 80px 100px;"><i class="el-icon-reading"></i></div>
                            <p >{{$t("kczx")}}</p>
                    </div>
                    <div class="mkr">
                        <div class="mkt" style="padding-top: 20px">
                                <div class="circle"  style="margin-left: 5px"><i class="el-icon-office-building"></i></div>
                                <p style="margin-left: 85px;margin-top: -50px">{{$t("jssbgl")}}</p>
                        </div>
                        <div class="mkb" style="padding-top: 25px">
                                <div class="circle" style="margin-left: 30px"><i class="el-icon-monitor"></i></div>
                                <p style="margin-left: 85px;margin-top: -50px">{{$t("jtpt")}}</p>
                        </div>
                    </div>
                    <div class="footer">
                        <div class="footer_bottom">
                            <div ><img style="margin-top: 50px;margin-left: 150px" src="../img/logo_bottom.png" alt=""/></div>

                        </div>
                    </div>

                </div>

        </div>
       </div>
        <!--尾部区域-->
        <!--<div class="footer">-->
        <!--    <div class="footer_bottom">-->
        <!--        <div class="footer_bottomL"><img style="margin-top: 30px" src="../img/logo_bottom.png" alt=""/></div>-->

        <!--    </div>-->
        <!--</div>-->
     </div>
 </div>
</template>

<script lang="ts" setup>
    export default {
        methods:{
            handle (){
                //  路径router目录下index.js中定义的path属性值
                this.$router.push('/');
            },
            changeType(type){
                console.log(type);
                this.$i18n.locale = type;
            }
        }
    }
</script>

<style scss>
    /*引入样式*/
    @import '../css/Page.css';

</style>